import React, { useEffect, useState, useRef } from 'react';
import { UploadIcon, CheckCircleIcon, ClockIcon, MailIcon, RefreshCwIcon, DownloadIcon, XIcon, UsersIcon, UserCheckIcon, ShieldCheckIcon, AlertCircleIcon, TrendingUpIcon } from 'lucide-react';
interface Supplier {
  id: string;
  name: string;
  email: string;
  paymentTerms: string;
  inviteSent: boolean;
  status: 'invited' | 'pending' | 'active';
  lastActivity: string;
  fundingActivity: string;
  source?: 'seed' | 'csv' | 'erp';
}
// Seeded suppliers - 12 invited (2 active, 3 pending, 7 invited)
const SEEDED_ACTIVATED_SUPPLIERS: Supplier[] = [{
  id: 'seed-001',
  name: 'Premium Textiles Inc',
  email: 'ap@premiumtextiles.com',
  paymentTerms: 'Net 60',
  inviteSent: true,
  status: 'active',
  lastActivity: '2025-01-15',
  fundingActivity: 'Accepted 2 offers this week',
  source: 'seed'
}, {
  id: 'seed-002',
  name: 'Global Apparel Wholesale',
  email: 'billing@globalapparel.com',
  paymentTerms: 'Net 45',
  inviteSent: true,
  status: 'active',
  lastActivity: '2025-01-14',
  fundingActivity: 'Consistent usage',
  source: 'seed'
}, {
  id: 'seed-003',
  name: 'Fashion Forward Distributors',
  email: 'accounts@fashionforward.com',
  paymentTerms: 'Net 30',
  inviteSent: true,
  status: 'pending',
  lastActivity: '2025-01-14',
  fundingActivity: 'Accepted initial advance',
  source: 'seed'
}, {
  id: 'seed-004',
  name: 'Metro Fabric Supply',
  email: 'payables@metrofabric.com',
  paymentTerms: 'Net 45',
  inviteSent: true,
  status: 'pending',
  lastActivity: '2025-01-13',
  fundingActivity: 'No funding yet',
  source: 'seed'
}, {
  id: 'seed-005',
  name: 'Coastal Textiles Group',
  email: 'finance@coastaltextiles.com',
  paymentTerms: 'Net 60',
  inviteSent: true,
  status: 'pending',
  lastActivity: '2025-01-12',
  fundingActivity: 'No funding yet',
  source: 'seed'
}, {
  id: 'seed-006',
  name: 'Riverside Manufacturing Co',
  email: 'ap@riversidemanufacturing.com',
  paymentTerms: 'Net 30',
  inviteSent: true,
  status: 'invited',
  lastActivity: '2025-01-11',
  fundingActivity: '—',
  source: 'seed'
}, {
  id: 'seed-007',
  name: 'Northern Logistics Partners',
  email: 'billing@northernlogistics.com',
  paymentTerms: 'Net 45',
  inviteSent: true,
  status: 'invited',
  lastActivity: '2025-01-10',
  fundingActivity: '—',
  source: 'seed'
}, {
  id: 'seed-008',
  name: 'Eastern Supply Chain Co',
  email: 'ap@easternsupply.com',
  paymentTerms: 'Net 60',
  inviteSent: true,
  status: 'invited',
  lastActivity: '2025-01-09',
  fundingActivity: '—',
  source: 'seed'
}, {
  id: 'seed-009',
  name: 'Western Materials Group',
  email: 'accounts@westernmaterials.com',
  paymentTerms: 'Net 30',
  inviteSent: true,
  status: 'invited',
  lastActivity: '2025-01-08',
  fundingActivity: '—',
  source: 'seed'
}, {
  id: 'seed-010',
  name: 'Southern Wholesale Inc',
  email: 'finance@southernwholesale.com',
  paymentTerms: 'Net 45',
  inviteSent: true,
  status: 'invited',
  lastActivity: '2025-01-07',
  fundingActivity: '—',
  source: 'seed'
}, {
  id: 'seed-011',
  name: 'Central Trading Partners',
  email: 'payables@centraltrading.com',
  paymentTerms: 'Net 60',
  inviteSent: true,
  status: 'invited',
  lastActivity: '2025-01-06',
  fundingActivity: '—',
  source: 'seed'
}, {
  id: 'seed-012',
  name: 'Pacific Distribution LLC',
  email: 'billing@pacificdist.com',
  paymentTerms: 'Net 30',
  inviteSent: true,
  status: 'invited',
  lastActivity: '2025-01-05',
  fundingActivity: '—',
  source: 'seed'
}];
// CSV suppliers - different from seeded ones
const CSV_SUPPLIERS: Supplier[] = [{
  id: 'csv-001',
  name: 'Apex Materials Corp',
  email: 'billing@apexmaterials.com',
  paymentTerms: 'Net 45',
  inviteSent: false,
  status: 'invited',
  lastActivity: '—',
  fundingActivity: '—',
  source: 'csv'
}, {
  id: 'csv-002',
  name: 'Delta Supply Chain Solutions',
  email: 'accounts@deltasupply.com',
  paymentTerms: 'Net 60',
  inviteSent: false,
  status: 'invited',
  lastActivity: '—',
  fundingActivity: '—',
  source: 'csv'
}, {
  id: 'csv-003',
  name: 'Horizon Trading Partners',
  email: 'ap@horizontrading.com',
  paymentTerms: 'Net 30',
  inviteSent: false,
  status: 'invited',
  lastActivity: '—',
  fundingActivity: '—',
  source: 'csv'
}];
// ERP suppliers - different from both seeded and CSV
const ERP_SUPPLIERS: Supplier[] = [{
  id: 'erp-001',
  name: 'Pacific Home Goods',
  email: 'payables@pacifichome.com',
  paymentTerms: 'Net 45',
  inviteSent: false,
  status: 'invited',
  lastActivity: '—',
  fundingActivity: '—',
  source: 'erp'
}, {
  id: 'erp-002',
  name: 'Summit Office Supply',
  email: 'finance@summitoffice.com',
  paymentTerms: 'Net 60',
  inviteSent: false,
  status: 'invited',
  lastActivity: '—',
  fundingActivity: '—',
  source: 'erp'
}, {
  id: 'erp-003',
  name: 'Omega Electronics Trading',
  email: 'ap@omegaelectronics.com',
  paymentTerms: 'Net 30',
  inviteSent: false,
  status: 'invited',
  lastActivity: '—',
  fundingActivity: '—',
  source: 'erp'
}];
export function AnchorPortal() {
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [suppliers, setSuppliers] = useState<Supplier[]>([]);
  const [activatedSuppliers, setActivatedSuppliers] = useState<Supplier[]>(SEEDED_ACTIVATED_SUPPLIERS);
  const [selectedSuppliers, setSelectedSuppliers] = useState<Set<string>>(new Set());
  const [showInviteSuccess, setShowInviteSuccess] = useState(false);
  const [showErpModal, setShowErpModal] = useState(false);
  const [csvSynced, setCsvSynced] = useState(false);
  const [erpSynced, setErpSynced] = useState(false);
  const [lastUploadTime, setLastUploadTime] = useState<string>('');
  const fileInputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    document.title = 'Mint | Treasury';
  }, []);
  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setUploadedFile(file);
      setCsvSynced(true);
      const now = new Date();
      const timeStr = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;
      setLastUploadTime(timeStr);
      setTimeout(() => {
        setSuppliers(prev => [...prev, ...CSV_SUPPLIERS]);
      }, 500);
    }
  };
  const handleErpSync = (system: string) => {
    setShowErpModal(false);
    setErpSynced(true);
    setTimeout(() => {
      setSuppliers(prev => [...prev, ...ERP_SUPPLIERS]);
      setShowInviteSuccess(true);
      setTimeout(() => setShowInviteSuccess(false), 3000);
    }, 500);
  };
  const handleClearImported = () => {
    setSuppliers([]);
    setUploadedFile(null);
    setCsvSynced(false);
    setErpSynced(false);
    setLastUploadTime('');
    setSelectedSuppliers(new Set());
  };
  const handleSelectAll = () => {
    if (selectedSuppliers.size === suppliers.length) {
      setSelectedSuppliers(new Set());
    } else {
      setSelectedSuppliers(new Set(suppliers.map(s => s.id)));
    }
  };
  const handleSelectSupplier = (id: string) => {
    const newSelected = new Set(selectedSuppliers);
    if (newSelected.has(id)) {
      newSelected.delete(id);
    } else {
      newSelected.add(id);
    }
    setSelectedSuppliers(newSelected);
  };
  const handleInviteSuppliers = () => {
    const invitedSuppliers = suppliers.filter(s => selectedSuppliers.has(s.id));
    const now = new Date().toISOString().split('T')[0];
    const newActivated = invitedSuppliers.map(supplier => ({
      ...supplier,
      inviteSent: true,
      status: 'invited' as const,
      lastActivity: now
    }));
    setActivatedSuppliers(prev => [...prev, ...newActivated]);
    setSuppliers(prev => prev.filter(s => !selectedSuppliers.has(s.id)));
    setSelectedSuppliers(new Set());
    setShowInviteSuccess(true);
    setTimeout(() => setShowInviteSuccess(false), 3000);
  };
  const getStatusBadge = (status: string) => {
    const styles = {
      invited: 'bg-blue-50 text-blue-700',
      pending: 'bg-yellow-50 text-yellow-700',
      active: 'bg-green-50 text-green-700'
    };
    return styles[status as keyof typeof styles] || styles.invited;
  };
  const invitedCount = activatedSuppliers.length;
  const pendingCount = activatedSuppliers.filter(s => s.status === 'pending').length;
  const activeCount = activatedSuppliers.filter(s => s.status === 'active').length;
  const csvSupplierCount = suppliers.filter(s => s.source === 'csv').length;
  const erpSupplierCount = suppliers.filter(s => s.source === 'erp').length;
  return <div className="min-h-screen bg-gray-50" data-id="element-625">
      <div className="max-w-7xl mx-auto" data-id="element-626">
        {/* Header */}
        <div className="mb-8" data-id="element-627">
          <h1 className="text-3xl font-semibold text-gray-900" data-id="element-628">Treasury</h1>
          <p className="text-gray-600 mt-1" data-id="element-629">Supplier Activation</p>
        </div>
        {/* Success Toast */}
        {showInviteSuccess && <div className="mb-6 bg-green-50 border border-green-200 rounded-lg p-4 flex items-center justify-between" data-id="element-630">
            <div className="flex items-center" data-id="element-631">
              <CheckCircleIcon size={20} className="text-green-600 mr-3" data-id="element-632" />
              <span className="text-sm text-green-800" data-id="element-633">
                Invitations sent successfully
              </span>
            </div>
            <button onClick={() => setShowInviteSuccess(false)} className="text-green-600 hover:text-green-700" data-id="element-634">
              <XIcon size={16} data-id="element-635" />
            </button>
          </div>}
        {/* Top Section: Activation Status + AI Intelligence */}
        <div className="grid grid-cols-3 gap-6 mb-8" data-id="element-636">
          {/* Left: Supplier Activation Status */}
          <div className="col-span-2 bg-white rounded-lg border border-gray-200" data-id="element-637">
            <div className="p-6 border-b border-gray-200" data-id="element-638">
              <div className="flex items-center justify-between mb-6" data-id="element-639">
                <div data-id="element-640">
                  <h2 className="text-lg font-medium text-gray-900" data-id="element-641">
                    Supplier Activation Status
                  </h2>
                </div>
                <button className="inline-flex items-center px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm" data-id="element-642">
                  <DownloadIcon size={16} className="mr-2" data-id="element-643" />
                  Export
                </button>
              </div>
              {/* Summary Cards */}
              <div className="grid grid-cols-3 gap-4" data-id="element-644">
                <div className="bg-gray-50 rounded-lg p-4" data-id="element-645">
                  <div className="flex items-center justify-between" data-id="element-646">
                    <div data-id="element-647">
                      <div className="text-xs text-gray-500 uppercase tracking-wide mb-1" data-id="element-648">
                        Suppliers Invited
                      </div>
                      <div className="text-2xl font-semibold text-gray-900" data-id="element-649">
                        {invitedCount}
                      </div>
                    </div>
                    <UsersIcon size={24} className="text-gray-400" data-id="element-650" />
                  </div>
                </div>
                <div className="bg-gray-50 rounded-lg p-4" data-id="element-651">
                  <div className="flex items-center justify-between" data-id="element-652">
                    <div data-id="element-653">
                      <div className="text-xs text-gray-500 uppercase tracking-wide mb-1" data-id="element-654">
                        Pending Activation
                      </div>
                      <div className="text-2xl font-semibold text-gray-900" data-id="element-655">
                        {pendingCount}
                      </div>
                    </div>
                    <ClockIcon size={24} className="text-gray-400" data-id="element-656" />
                  </div>
                </div>
                <div className="bg-gray-50 rounded-lg p-4" data-id="element-657">
                  <div className="flex items-center justify-between" data-id="element-658">
                    <div data-id="element-659">
                      <div className="text-xs text-gray-500 uppercase tracking-wide mb-1" data-id="element-660">
                        Active Suppliers
                      </div>
                      <div className="text-2xl font-semibold text-gray-900" data-id="element-661">
                        {activeCount}
                      </div>
                    </div>
                    <UserCheckIcon size={24} className="text-gray-400" data-id="element-662" />
                  </div>
                </div>
              </div>
            </div>
            {/* Activation Table */}
            <div className="overflow-x-auto" data-id="element-663">
              <table className="min-w-full divide-y divide-gray-200" data-id="element-664">
                <thead className="bg-gray-50" data-id="element-665">
                  <tr data-id="element-666">
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-667">
                      Supplier Name
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-668">
                      Invite Sent
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-669">
                      Status
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-670">
                      Funding Activity
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-671">
                      Last Activity
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200" data-id="element-672">
                  {activatedSuppliers.map(supplier => <tr key={supplier.id} className="hover:bg-gray-50" data-id="element-673">
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-674">
                        {supplier.name}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-675">
                        <div className="flex items-center text-sm text-gray-600" data-id="element-676">
                          <CheckCircleIcon size={16} className="text-green-600 mr-2" data-id="element-677" />
                          Yes
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-678">
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusBadge(supplier.status)}`} data-id="element-679">
                          {supplier.status === 'invited' && <MailIcon size={12} className="mr-1" data-id="element-680" />}
                          {supplier.status === 'pending' && <ClockIcon size={12} className="mr-1" data-id="element-681" />}
                          {supplier.status === 'active' && <CheckCircleIcon size={12} className="mr-1" data-id="element-682" />}
                          {supplier.status.charAt(0).toUpperCase() + supplier.status.slice(1)}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600" data-id="element-683">
                        {supplier.fundingActivity}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600" data-id="element-684">
                        {supplier.lastActivity}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
          {/* Right: Mint Intelligence Overview */}
          <div className="space-y-4" data-id="element-685">
            <div className="text-xs font-semibold text-gray-600 uppercase tracking-wide mb-2" data-id="element-686">
              Mint Intelligence Overview
            </div>
            <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-687">
              <div className="flex items-start justify-between mb-3" data-id="element-688">
                <div data-id="element-689">
                  <div className="text-xs text-gray-500 uppercase tracking-wide mb-1" data-id="element-690">
                    Invoices Validated
                  </div>
                  <div className="text-2xl font-semibold text-gray-900" data-id="element-691">
                    100%
                  </div>
                </div>
                <ShieldCheckIcon size={20} className="text-green-600" data-id="element-692" />
              </div>
            </div>
            <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-693">
              <div className="flex items-start justify-between mb-3" data-id="element-694">
                <div data-id="element-695">
                  <div className="text-xs text-gray-500 uppercase tracking-wide mb-1" data-id="element-696">
                    Buyer Legitimacy
                  </div>
                  <div className="text-2xl font-semibold text-gray-900" data-id="element-697">
                    Stable
                  </div>
                </div>
                <CheckCircleIcon size={20} className="text-green-600" data-id="element-698" />
              </div>
            </div>
            <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-699">
              <div className="flex items-start justify-between mb-3" data-id="element-700">
                <div data-id="element-701">
                  <div className="text-xs text-gray-500 uppercase tracking-wide mb-1" data-id="element-702">
                    Authenticity Score
                  </div>
                  <div className="text-2xl font-semibold text-gray-900" data-id="element-703">
                    99.3%
                  </div>
                </div>
                <TrendingUpIcon size={20} className="text-green-600" data-id="element-704" />
              </div>
            </div>
            <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-705">
              <div className="flex items-start justify-between mb-3" data-id="element-706">
                <div data-id="element-707">
                  <div className="text-xs text-gray-500 uppercase tracking-wide mb-1" data-id="element-708">
                    Anomalies Detected
                  </div>
                  <div className="text-2xl font-semibold text-gray-900" data-id="element-709">0</div>
                </div>
                <AlertCircleIcon size={20} className="text-gray-400" data-id="element-710" />
              </div>
            </div>
          </div>
        </div>
        {/* Middle: Invite Suppliers Section */}
        <div className="bg-white rounded-lg border border-gray-200 mb-8" data-id="element-711">
          <div className="p-6 border-b border-gray-200" data-id="element-712">
            <div className="flex items-center justify-between" data-id="element-713">
              <div data-id="element-714">
                <h2 className="text-lg font-medium text-gray-900" data-id="element-715">
                  Invite Suppliers
                </h2>
              </div>
              <div className="flex items-center gap-3" data-id="element-716">
                {suppliers.length > 0 && <button onClick={handleClearImported} className="text-sm text-gray-600 hover:text-gray-800 font-medium" data-id="element-717">
                    Clear imported list
                  </button>}
                {selectedSuppliers.size > 0 && <button onClick={handleInviteSuppliers} className="inline-flex items-center px-4 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors text-sm" data-id="element-718">
                    <MailIcon size={16} className="mr-2" data-id="element-719" />
                    Invite {selectedSuppliers.size} Supplier
                    {selectedSuppliers.size > 1 ? 's' : ''}
                  </button>}
              </div>
            </div>
            {/* Upload Status Banners */}
            {csvSynced && csvSupplierCount > 0 && <div className="mt-4 flex items-center justify-between bg-blue-50 border border-blue-200 rounded-lg px-4 py-2" data-id="element-720">
                <div className="flex items-center text-sm text-blue-800" data-id="element-721">
                  <CheckCircleIcon size={16} className="text-blue-600 mr-2" data-id="element-722" />
                  Uploaded {uploadedFile?.name || 'Book2.csv'} with{' '}
                  {csvSupplierCount} suppliers
                  {lastUploadTime && ` at ${lastUploadTime}`}
                </div>
              </div>}
            {erpSynced && erpSupplierCount > 0 && <div className="mt-4 flex items-center justify-between bg-green-50 border border-green-200 rounded-lg px-4 py-2" data-id="element-723">
                <div className="flex items-center text-sm text-green-800" data-id="element-724">
                  <CheckCircleIcon size={16} className="text-green-600 mr-2" data-id="element-725" />
                  Synced from QuickBooks with {erpSupplierCount} suppliers
                </div>
              </div>}
          </div>
          <div className="overflow-x-auto" data-id="element-726">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-727">
              <thead className="bg-gray-50" data-id="element-728">
                <tr data-id="element-729">
                  <th className="px-6 py-3 text-left" data-id="element-730">
                    <input type="checkbox" checked={suppliers.length > 0 && selectedSuppliers.size === suppliers.length} onChange={handleSelectAll} disabled={suppliers.length === 0} className="rounded border-gray-300 text-gray-800 focus:ring-gray-500 disabled:opacity-50" data-id="element-731" />
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-732">
                    Supplier Name
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-733">
                    Email
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-734">
                    Payment Terms
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-735">
                {suppliers.length === 0 ? <tr data-id="element-736">
                    <td colSpan={4} className="px-6 py-12 text-center text-sm text-gray-500" data-id="element-737">
                      Upload or sync your supplier list to start inviting
                    </td>
                  </tr> : suppliers.map(supplier => <tr key={supplier.id} className="hover:bg-gray-50 transition-colors" data-id="element-738">
                      <td className="px-6 py-4" data-id="element-739">
                        <input type="checkbox" checked={selectedSuppliers.has(supplier.id)} onChange={() => handleSelectSupplier(supplier.id)} className="rounded border-gray-300 text-gray-800 focus:ring-gray-500" data-id="element-740" />
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-741">
                        {supplier.name}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600" data-id="element-742">
                        {supplier.email}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600" data-id="element-743">
                        {supplier.paymentTerms}
                      </td>
                    </tr>)}
              </tbody>
            </table>
          </div>
        </div>
        {/* Bottom: Upload or Sync Section */}
        <div className="bg-white rounded-lg border border-gray-200 p-8" data-id="element-744">
          <div className="max-w-2xl mx-auto" data-id="element-745">
            <div className="mb-6 text-center" data-id="element-746">
              <h2 className="text-lg font-medium text-gray-900 mb-2" data-id="element-747">
                Upload or Sync Supplier List
              </h2>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 justify-center" data-id="element-748">
              <button onClick={() => fileInputRef.current?.click()} className="inline-flex items-center justify-center px-6 py-3 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors text-sm" data-id="element-749">
                <UploadIcon size={18} className="mr-2" data-id="element-750" />
                Upload CSV
              </button>
              <button onClick={() => setShowErpModal(true)} className="inline-flex items-center justify-center px-6 py-3 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm" data-id="element-751">
                <RefreshCwIcon size={18} className="mr-2" data-id="element-752" />
                Sync from ERP
              </button>
            </div>
            <input ref={fileInputRef} type="file" accept=".csv" onChange={handleFileUpload} className="hidden" data-id="element-753" />
          </div>
        </div>
      </div>
      {/* ERP Sync Modal */}
      {showErpModal && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-754">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4" data-id="element-755">
            <div className="p-6 border-b border-gray-200" data-id="element-756">
              <div className="flex items-center justify-between" data-id="element-757">
                <h3 className="text-lg font-medium text-gray-900" data-id="element-758">
                  Sync from ERP
                </h3>
                <button onClick={() => setShowErpModal(false)} className="text-gray-400 hover:text-gray-500" data-id="element-759">
                  <XIcon size={20} data-id="element-760" />
                </button>
              </div>
            </div>
            <div className="p-6" data-id="element-761">
              <p className="text-sm text-gray-600 mb-4" data-id="element-762">
                Select your ERP system to sync supplier data
              </p>
              <div className="space-y-2" data-id="element-763">
                <button onClick={() => handleErpSync('QuickBooks')} className="w-full flex items-center justify-between px-4 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors text-left" data-id="element-764">
                  <span className="text-sm font-medium text-gray-900" data-id="element-765">
                    QuickBooks
                  </span>
                  <span className="text-xs text-green-600 font-medium" data-id="element-766">
                    Active
                  </span>
                </button>
                <button disabled className="w-full flex items-center justify-between px-4 py-3 border border-gray-200 rounded-lg bg-gray-50 cursor-not-allowed text-left" data-id="element-767">
                  <span className="text-sm font-medium text-gray-400" data-id="element-768">
                    NetSuite
                  </span>
                  <span className="text-xs text-gray-400" data-id="element-769">Coming soon</span>
                </button>
                <button disabled className="w-full flex items-center justify-between px-4 py-3 border border-gray-200 rounded-lg bg-gray-50 cursor-not-allowed text-left" data-id="element-770">
                  <span className="text-sm font-medium text-gray-400" data-id="element-771">SAP</span>
                  <span className="text-xs text-gray-400" data-id="element-772">Coming soon</span>
                </button>
              </div>
            </div>
            <div className="p-6 border-t border-gray-200 flex justify-end" data-id="element-773">
              <button onClick={() => setShowErpModal(false)} className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-800" data-id="element-774">
                Cancel
              </button>
            </div>
          </div>
        </div>}
    </div>;
}